import {
  CreateComplaintArgs,
  ComplaintCreationDetailsDto,
  ComplaintCreationOrderDto,
  ComplaintCreationOrderItemDto,
  ComplaintCreationOrderItemDetailsDto,
  ComplaintCreationItemReasonDto,
  ComplaintCreationDetailsModel,
  ComplaintCreationOrderModel,
  ComplaintCreationOrderItemModel,
  ComplaintCreationOrderItemDetailsModel,
  ComplaintCreationItemReasonModel,
} from '../types/complaint-creation'
import { transformCurrencyAmountDto } from './currency-amount'

export const getCreateComplaintArgs = ({
  faqEntryId,
  ch,
  problemTextId,
  transactionId,
  threadId,
  tempUuid,
  message,
  isEnglishAllowed,
  itemId,
  memberId,
  email,
  complaintOrderItems,
  type,
}: CreateComplaintArgs) => ({
  faq_entry_id: faqEntryId,
  ch,
  transaction_id: transactionId,
  thread_id: threadId,
  problem_text_id: problemTextId,
  temp_uuid: tempUuid,
  help_contact_form: {
    message,
    english_allowed: isEnglishAllowed,
    item_id: itemId,
    transaction_id: transactionId,
    member_id: memberId,
    email,
  },
  complaint_order_items: complaintOrderItems?.map(item => ({
    order_item_id: item.orderItemId,
    reason: item.code,
  })),
  type,
})

export const transformComplaintCreationOrderItemDetails = (
  item: ComplaintCreationOrderItemDetailsDto,
): ComplaintCreationOrderItemDetailsModel => ({
  itemId: item.item_id,
  title: item.title,
  size: item.size,
  itemStatus: item.item_status,
  image: item.thumbnail_150x210,
  isElectronics: item.is_electronics,
})

export const transformComplaintCreationOrderItem = (
  orderItem: ComplaintCreationOrderItemDto,
): ComplaintCreationOrderItemModel => ({
  orderItemId: orderItem.order_item_id,
  item: transformComplaintCreationOrderItemDetails(orderItem.item),
})

export const transformComplaintCreationOrderItems = (
  orderItems: Array<ComplaintCreationOrderItemDto>,
): Array<ComplaintCreationOrderItemModel> => orderItems.map(transformComplaintCreationOrderItem)

export const transformComplaintCreationOrder = (
  order: ComplaintCreationOrderDto,
): ComplaintCreationOrderModel => ({
  title: order.title,
  sellerUsername: order.seller_username,
  isBundleOrder: order.is_bundle_order,
  withAuthenticityCheck: order.with_authenticity_check,
  withElectronicsVerification: order.with_electronics_verification,
  orderType: order.order_type,
  orderPrice: transformCurrencyAmountDto(order.order_price),
  orderItems: transformComplaintCreationOrderItems(order.order_items),
})

export const transformComplaintCreationReason = (
  reason: ComplaintCreationItemReasonDto,
): ComplaintCreationItemReasonModel => ({
  code: reason.code,
  reasonText: reason.reason_text,
})

export const transformComplaintCreationReasons = (
  reasons: Array<ComplaintCreationItemReasonDto>,
): Array<ComplaintCreationItemReasonModel> => reasons.map(transformComplaintCreationReason)

export const transformComplaintCreationDetails = ({
  complaint_creation_details,
}: {
  complaint_creation_details: ComplaintCreationDetailsDto
}): ComplaintCreationDetailsModel => ({
  order: transformComplaintCreationOrder(complaint_creation_details.order),
  reasons: transformComplaintCreationReasons(complaint_creation_details.reasons),
  userMsgThreadId: complaint_creation_details.user_msg_thread_id,
  reportDeadline: complaint_creation_details.report_deadline,
})
